import clsx from "clsx"

import { Tab } from "components/navigation/Tabs"
import { Column } from "components/tables/DataTable"

import { GgrByCountryRow, GgrByPlayerRow, GgrByProviderRow, GgrSummaryType } from "services/total/types"

import { formatFiatCurrency } from "util/formatter"

export const BAR_COLORS = ["#8b5cf6", "#06b6d4", "#f59e0b", "#10b981", "#ef4444", "#3b82f6", "#ec4899", "#14b8a6", "#f97316", "#6366f1"]

export const GGR_TABS: Tab[] = [
  { key: GgrSummaryType.Provider, label: "charts.byProvider" },
  { key: GgrSummaryType.Country, label: "charts.byCountry" },
  { key: GgrSummaryType.Player, label: "charts.byPlayer" }
]

export const providerColumns: Column<GgrByProviderRow>[] = [
  { header: "#", render: (_, i) => i + 1 },
  {
    header: "Provider",
    render: (r) => (
      <>
        <span className="font-medium text-white">{r.providerTitle}</span>
        <span className="ml-1 text-xs text-gray-500">({r.provider})</span>
      </>
    )
  },
  { header: "Wager", align: "right", render: (r) => formatFiatCurrency(r.wager, "$0.00") },
  { header: "Win", align: "right", render: (r) => formatFiatCurrency(r.win, "$0.00") },
  { header: "Bets", align: "right", render: (r) => r.betCount.toLocaleString() },
  {
    header: "GGR",
    align: "right",
    sortable: true,
    sortKey: "ggr",
    render: (r) => (
      <span className={clsx("font-semibold", r.ggr >= 0 ? "text-emerald-400" : "text-rose-400")}>{formatFiatCurrency(r.ggr, "$0.00")}</span>
    )
  }
]

export const countryColumns: Column<GgrByCountryRow>[] = [
  { header: "#", render: (_, i) => i + 1 },
  { header: "Country", render: (r) => <span className="font-medium text-white">{r.country}</span> },
  { header: "Wager", align: "right", render: (r) => formatFiatCurrency(r.wager, "$0.00") },
  { header: "Win", align: "right", render: (r) => formatFiatCurrency(r.win, "$0.00") },
  { header: "Bets", align: "right", render: (r) => r.betCount.toLocaleString() },
  { header: "Players", align: "right", render: (r) => r.playerCount.toLocaleString() },
  {
    header: "GGR",
    align: "right",
    sortable: true,
    sortKey: "ggr",
    render: (r) => (
      <span className={clsx("font-semibold", r.ggr >= 0 ? "text-emerald-400" : "text-rose-400")}>{formatFiatCurrency(r.ggr, "$0.00")}</span>
    )
  }
]

export const playerColumns: Column<GgrByPlayerRow>[] = [
  { header: "#", render: (_, i) => i + 1 },
  {
    header: "Player",
    render: (r) => (
      <div className="flex flex-col">
        <span className="font-medium text-white">{r.username || "—"}</span>
        <span className="text-xs text-gray-500">{r.email || r.userId}</span>
      </div>
    )
  },
  { header: "Wager", align: "right", render: (r) => formatFiatCurrency(r.wager, "$0.00") },
  { header: "Win", align: "right", render: (r) => formatFiatCurrency(r.win, "$0.00") },
  { header: "Bets", align: "right", render: (r) => r.betCount.toLocaleString() },
  {
    header: "GGR",
    align: "right",
    sortable: true,
    sortKey: "ggr",
    render: (r) => (
      <span className={clsx("font-semibold", r.ggr >= 0 ? "text-emerald-400" : "text-rose-400")}>{formatFiatCurrency(r.ggr, "$0.00")}</span>
    )
  }
]
